module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vscroller"
  }, [_c('div', {
    staticClass: "vscroller__head"
  }, [_vm._v(_vm._s(_vm.scrollerTitle))]), _vm._v(" "), _c('div', {
    staticClass: "vscroller__body"
  }, [_c('ul', {
    ref: "ul",
    style: ({
      webkitTransition: '-webkit-transform ' + _vm.transitionDuration / 1000 + 's ease-out',
      transition: 'transform ' + _vm.transitionDuration / 1000 + 's ease-out',
      webkitTransform: 'translate3d(0px, ' + _vm.currentTranslatedY + 'px, 0px)',
      transform: 'translate3d(0px, ' + _vm.currentTranslatedY + 'px, 0px)'
    })
  }, _vm._l((_vm.itemList), function(item) {
    return _c('li', {
      key: item.id,
      class: item.selected ? 'vselected' : '',
      attrs: {
        "data-val": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-loader/11.1.4/vue-loader/lib/template-compiler.js?{"id":"data-v-0e1129fb"}!./~/.npminstall/vue-loader/11.1.4/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scroller.vue
// module id = 8
// module chunks = 0